import Pluralize from "typescript-pluralize";
import { camalizeString } from "../../../strings/camel";
import { identifier } from "../../ast/identifier";
import { pascalCase } from "pascal-case";
export function getEntityName(entity) {
    return camalizeString(entity.getName());
}
export function getListComponentName(entity) {
    return pascalCase(entity.getName() + "List");
}
export function getListPageComponentName(entity) {
    return pascalCase(getListComponentName(entity) + "Page");
}
export function getInputParameterIdentifier(entity) {
    return identifier(getPluralizedEntityName(entity.getName()));
}
export function getPluralizedEntityName(entityName) {
    return Pluralize.plural(camalizeString(entityName));
}
